import { useI18n } from "@/hooks/use-i18n";
import { Language } from "@/lib/i18n";
import { Globe } from "lucide-react";

const LANG_CYCLE: Language[] = ["en", "fr", "de"];

export function LanguageSwitcher() {
  const { lang, setLang } = useI18n();

  const next = () => {
    const idx = LANG_CYCLE.indexOf(lang);
    setLang(LANG_CYCLE[(idx + 1) % LANG_CYCLE.length]);
  };

  return (
    <button
      onClick={next}
      className="flex items-center gap-1.5 rounded-lg bg-secondary px-2.5 py-1.5 text-xs font-semibold uppercase text-foreground hover:bg-secondary/80 transition-colors"
      title="Change language"
    >
      <Globe className="h-3.5 w-3.5" />
      {lang}
    </button>
  );
}
